import { Star } from "lucide-react";
import { cn } from "@/lib/utils";

type RatingStarsProps = {
  rating?: number;
  className?: string;
  size?: "sm" | "md";
};

export function RatingStars({ rating = 4, className, size = "md" }: RatingStarsProps) {
  const px = size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4";
  return (
    <span
      className={cn("inline-flex items-center gap-0.5", className)}
      role="img"
      aria-label={`${rating} de 5 estrelas`}
    >
      {Array.from({ length: 5 }).map((_, index) => (
        <Star
          key={index}
          className={cn(px, "text-[#c09214]", index < rating ? "fill-[#c09214]" : "fill-none")}
          strokeWidth={1.75}
          aria-hidden
        />
      ))}
    </span>
  );
}
